export const environment = {
  production: true,
  apiUrl: 'https://api.lagoon.co.uk',
  api2Url: 'https://api2.lagoon.co.uk/api'

};
